import React, { useEffect, useRef } from 'react';
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  ClickAwayListener,
  Divider,
  Grid,
  Grow,
  MenuList,
  Popper,
  Typography
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import InfoIcon from '@mui/icons-material/Info';
import { styled } from '@mui/material/styles';
import { connect, useDispatch, useSelector } from 'react-redux';
import { updateWarrantyApiCall, updateCoreApiCall } from './Action';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { orderStatusMap, quotesStatus } from '../../defined';
import {
  filterQuoteStatus,
  filterQuoteStatusColor,
  getFleetStatusConfig,
  getValueFromObjectByKeys,
  handleStatus,
  MESSAGE_TYPE,
  messageManager,
  translate
} from '../../helper';
import ImageSliderComponent from '../../common/image-slider/ImageSlider.component';
import APIManager from '../../connection/ApiManager';
import 'firebase/compat/firestore';
import ImageZoom from '../../common/image-zoom';
import './style.css';
import QuotesModal from './QuotesModal';
import { PageBox, SendButton, OdFontScale } from './components';
import Utils from '../../utils';
import {
  setOrderDetailsSlice,
  setOrderDetailsSliceData
} from '../../mobile/modules/Orders/Slice/ordersDetailSlice';
import MessagesList from './MessagesList';
import InfoCard from './InfoCard';
import CustomTooltip from '../../common/CustomTooltip';
import ReconnectingWebSocket from 'reconnecting-websocket';
import ContactIcon from './ContactIcon';
import BusinessAccountModal from './BusinessAccountModal.js';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { SVGImageComponentReact } from '../../themes/Images.js';
import { formatDate, resolveCssVarValue } from '../../utils/CommonFunction.js';
import { DISPLAY_ONLY_DATE_FORMAT, getQuoteAmount, SHOW_MONTH_NAME_FORMAT } from './helper.js';
import CustomSpinner from '../../common/CustomSpinner/index.js';
import ThumbDefault from '../../assets/image/svg/Thumb_default.svg';
import { usePermissions } from '../../hooks/usePermissions';
import ChatMessageModal from '../../common/modals/ChatMessageModal.js';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import PersonIcon from '@mui/icons-material/Person';
import dayjs from 'dayjs';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import PageTitleHeader from '../../common/page-title-header';

const RoundedBoxIcon = styled('span')(() => ({
  borderRadius: 'var(--sp-xxs)',
  width: 'var(--fs-md)',
  height: 'var(--fs-md)',
  border: 'calc(var(--fs-xs)*0.14150943) solid #CBD5E1',
  background: 'linear-gradient(180deg, #FFFFFF 0%, #F8FAFC 100%)',
  display: 'inline-block',
  boxSizing: 'border-box',
  transition: 'all 0.18s ease',
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.9), 0 1px 2px rgba(15,23,42,0.06)'
}));

const RoundedCheckedIcon = styled(RoundedBoxIcon)(() => ({
  position: 'relative',

  background: 'linear-gradient(180deg, #22C55E 0%, #16A34A 100%)',

  borderColor: '#16A34A',

  boxShadow: '0 4px 10px rgba(34,197,94,0.22), inset 0 1px 0 rgba(255,255,255,0.18)',

  '&::after': {
    content: '""',
    position: 'absolute',

    top: '50%',
    left: '50%',

    width: 'var(--fs-xs)',
    height: 'var(--fs-xs)',

    transform: 'translate(-50%, -50%)',

    backgroundImage: `url("data:image/svg+xml;utf8,${encodeURIComponent(
      "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='white' d='M20.285 6.709a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L9.5 15.914l9.371-9.371a1 1 0 0 1 1.414 0z'/></svg>"
    )}")`,

    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'var(--fs-md)'
  }
}));

const formatElapsedDuration = (startTime, endTime = new Date()) => {
  if (!startTime || !endTime) return 'N/A';
  const start = new Date(startTime);
  const end = new Date(endTime);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return 'N/A';

  const totalSeconds = Math.max(0, Math.floor((end.getTime() - start.getTime()) / 1000));
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (days > 0) return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  if (hours > 0) return `${hours}h ${minutes}m ${seconds}s`;
  if (minutes > 0) return `${minutes}m ${seconds}s`;
  return `${seconds}s`;
};

const ButtonsContainer = styled(Box)(({ theme, isBothButtonsVisible }) => ({
  marginRight: 'var(--sp-md2)',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  gap: 'var(--sp-md2)',

  ...(isBothButtonsVisible && {
    width: 'auto',
    minWidth: 'calc(var(--fs-hero)*12.2641509)', // Space for both buttons
    '& button': {
      flex: '1 1 calc(50% - var(--sp-md2))',
      minWidth: 'calc(var(--fs-hero)*3.60849)',
      whiteSpace: 'nowrap'
    }
  }),

  ...(!isBothButtonsVisible && {
    minWidth: 'calc(var(--fs-hero)*3.60849)',
    '& button': {
      width: '100%'
    }
  }),

  // Mobile responsive
  '@media (max-width: 1200px)': {
    ...(isBothButtonsVisible && {
      flexDirection: 'column',
      width: '100%',
      minWidth: 'unset',
      '& button': {
        width: '100%',
        whiteSpace: 'normal'
      }
    })
  }
}));

const ImageSkeleton = () => (
  <Box
    sx={{
      height: '61vh',
      borderRadius: 'var(--sp-md)',
      margin: '0 calc(var(--sp-xl) * 3 + var(--sp-md2)) 0 calc(var(--sp-xl) * 3)',
      marginTop: 'calc(var(--sp-md2)*3)',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
    <CustomSpinner size={resolveCssVarValue('--fs-hero') * 1.32075} top={0} />
  </Box>
);

const OrderDetailPage = (props) => {
  // RBAC edit permission check
  const { canEdit } = usePermissions();
  const canEditOrder = canEdit('order_list');
  // State for selected parts and icons (for Service Writer action)
  const [selectedPartIds, setSelectedPartIds] = React.useState([]);
  const [selectedIcons, setSelectedIcons] = React.useState({});
  const [validImages, setValidImages] = React.useState([]);
  const [checkingImages, setCheckingImages] = React.useState(true);
  const prevImageUrlsRef = useRef(null);
  const [openWarrantyMenu, setOpenWarrantyMenu] = React.useState(false);
  const warrantyAnchorRef = React.useRef(null);

  const handleWarrantyClose = () => {
    setOpenWarrantyMenu(false);
  };
  function getQuoteTotal(parts) {
    return (parts || [])
      .filter((p) => p.status === 2)
      .reduce((sum, p) => sum + (Number(p.value) || 0), 0);
  }
  const { userInfo: { profile: { user, vendor } = {} } = {} } = props;
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const firebaseSnapRef = useRef(null);
  const {
    data: { orderDetail, warrantyStatus, quotesData, coreStatus }
  } = useSelector((state) => state.orderDetail);
  const isDTCreatedOrder = orderDetail?.user?.role === 'DT'; // Indicates whether the order was created by a DT user.
  const firstQuoteStatus = orderDetail?.quotes?.[0]?.status || '';
  const setOrderDetails = (data) => dispatch(setOrderDetailsSlice({ key: 'orderDetail', data }));
  const setWarrantyStatus = (data) =>
    dispatch(setOrderDetailsSlice({ key: 'warrantyStatus', data }));
  const setCoreStatus = (data) => dispatch(setOrderDetailsSlice({ key: 'coreStatus', data }));

  function getTopActionButtonLabel({ isSentQuote, parts, translate, firstQuoteStatus }) {
    if (
      firstQuoteStatus === 'CUSTOMER ACCEPTED' ||
      firstQuoteStatus === 'SERVICE ACCEPTED PENDING'
    ) {
      return translate('finalizePaymentSendInvoice');
    }
    if (firstQuoteStatus === 'ACCEPTED') {
      return translate('viewInvoice');
    }
    if (isSentQuote && getQuoteTotal(parts) === 0) {
      return translate('editQuoteStatus');
    } else if (!isSentQuote) {
      return isDTCreatedOrder ? translate('sendQuoteToService') : translate('sendQuoteStatus');
    }
    return '';
  }

  const [openStartThread, setOpenStartThread] = React.useState(false);
  const [openSendQuote, setOpenSendQuote] = React.useState(false);
  const [isPartsMode, setIsPartsMode] = React.useState(false);
  const [openBusinessInfo, setOpenBusinessInfo] = React.useState(false);
  const [openReply, setOpenReply] = React.useState(false);
  const [timerElapsed, setTimerElapsed] = React.useState('');
  const [serviceAwaitingElapsed, setServiceAwaitingElapsed] = React.useState('');
  const [serviceAcceptedElapsed, setServiceAcceptedElapsed] = React.useState('');
  const timerIntervalRef = useRef(null);
  const serviceAwaitingTimerRef = useRef(null);
  const messagesEnd = React.useRef();
  const [loading, setLoading] = React.useState(true);
  const [messages, setMessages] = React.useState([]);
  const [messagesLoading, setMessagesLoading] = React.useState(true);
  const [changingWarrantyStatus, setChangingWarrantyStatus] = React.useState(false);
  const [changingCoreStatus, setChangingCoreStatus] = React.useState(false);
  const fixedAttributeDisplayname = orderDetail?.vendors?.[0]?.fixed_attribute_display_names || {};
  const deliverLabelMap = {
    instore: translate('acceptedInStorePickup'),
    delivery: translate('acceptedDelivery')
  };
  const [basicInfo, setBasicInfo] = React.useState([]);
  const parentBoxRef = React.useRef(null);
  const [chatBoxHeight, setChatBoxHeight] = React.useState(0);
  useEffect(() => {
    const calculateChatBoxHeight = () => {
      const viewportHeight = window.innerHeight;
      const parentBox = parentBoxRef.current;

      if (parentBox) {
        const parentBoxTop = parentBox.getBoundingClientRect().height;
        const remainingHeight = parentBoxTop - resolveCssVarValue('--fs-hero') * 1.6509433;
        setChatBoxHeight(remainingHeight > 0 ? remainingHeight : 0);
      }
    };
    calculateChatBoxHeight();
    window.addEventListener('resize', calculateChatBoxHeight);

    return () => {
      window.removeEventListener('resize', calculateChatBoxHeight);
    };
  }, [orderDetail, parentBoxRef.current]);

  const isUserTeamMember = props.userInfo?.profile?.team_member;
  const isUserServiceWriter = user?.role === 'SW';
  const statusLabel =
    orderDetail && handleStatus(orderDetail, isUserServiceWriter, isUserTeamMember);
  const statusColor = filterQuoteStatusColor(statusLabel, isUserServiceWriter, isUserTeamMember);
  const status = filterQuoteStatus(statusLabel, isUserServiceWriter, isUserTeamMember);
  const isUserActionRequired = isUserServiceWriter && status === 'Action Required';
  const [swActionLoading, setSwActionLoading] = React.useState(false);

  // Only initialize selected parts/icons if user hasn't made a selection yet
  React.useEffect(() => {
    if (orderDetail?.parts) {
      setSelectedPartIds((prev) => {
        if (prev.length === 0) {
          return orderDetail.parts.filter((p) => p.status === 2).map((p) => p.id);
        }
        return prev;
      });
      setSelectedIcons((prev) => {
        if (Object.keys(prev).length === 0) {
          const icons = {};
          orderDetail.parts.forEach((p) => {
            if (p.status === 2) icons[p.id] = 'check';
          });
          return icons;
        }
        return prev;
      });
    }
  }, [orderDetail?.parts]);

  // Add helper functions to determine which buttons to show
  const shouldShowAcceptAndPay = () => {
    // 1. If user is service writer, always show
    if (isUserActionRequired) return true;

    // 3. If user is White Label Partner Admin AND order creator is DT
    // Show Accept & Pay only if quotes exist
    if (user?.role === 'White Label Partner Admin' && isDTCreatedOrder) {
      return orderDetail?.quotes?.length > 0 && status === 'Quote Sent';
    }

    return false;
  };

  const shouldShowTopButton = () => {
    // 2. If user is NOT service writer, show top button
    if (!isUserServiceWriter) return true;
    return false;
  };

  const isFleetOrder = quotesData?.isPartsOrdered === true;

  const shouldShowPartsOrderedButton = () => {
    return !isUserServiceWriter && isDTCreatedOrder && (isFleetOrder || orderDetail?.quotes?.length === 0);
  };
  const isBothButtonsVisible =
    !isFleetOrder &&
    shouldShowTopButton() &&
    (shouldShowAcceptAndPay() || shouldShowPartsOrderedButton());

  // Handler for icon click (check/cross)
  const handleIconClick = (partId, iconType) => {
    setSelectedIcons((prev) => {
      const updatedIcons = { ...prev };
      if (iconType === 'check') {
        updatedIcons[partId] = 'check';
      } else if (iconType === 'cancel') {
        updatedIcons[partId] = 'cancel';
      } else {
        delete updatedIcons[partId];
      }
      return updatedIcons;
    });
    setSelectedPartIds((prev) => {
      if (iconType === 'check') {
        if (!prev.includes(partId)) {
          return [...prev, partId];
        }
        return prev;
      } else if (iconType === 'cancel') {
        return prev.filter((id) => id !== partId);
      } else {
        return prev.filter((id) => id !== partId);
      }
    });
  };

  if (!id) {
    navigate('/order');
  }
  const wsNotifications = useRef(null);

  const acceptServiceAndPay = async () => {
    try {
      setSwActionLoading(true);
      const params = {
        parts: selectedPartIds,
        quote: quotesData.id
      };
      await APIManager.getInstance().acceptServiceAndPay(params);
      Utils.showAlert(1, 'Service Accepted Successfully');
      setOrderDetails({
        ...orderDetail,
        status: 'SERVICE ACCEPTED PENDING'
      });
      getData();
    } catch (e) {
      Utils.showAlert(2, 'OOPS! something went wrong! Please try again');
    } finally {
      setSwActionLoading(false);
    }
  };

  const getData = async () => {
    if (!id) return;
    try {
      const resDetail = await APIManager.getInstance().getOrderDetail(id);
      const orderDetail = resDetail?.data;
      dispatch(setOrderDetailsSliceData({ orderDetail }));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const vendors = orderDetail?.vendors;
  const vendorId = vendors ? vendors[0]?.id || vendors[0] : null;
  const quotes = orderDetail?.quotes || [];
  const quoteItem = quotes.find((x) => x?.vendor?.id === vendorId);
  const isSentQuote = !!quoteItem;
  const isVendor = (orderDetail?.vendors || []).find(
    (x) => x.id === vendorId || x.id === vendor?.id
  );

  const isOrderFulfillment =
    orderDetail?.status === orderStatusMap.PROCESSING ||
    orderDetail?.status === orderStatusMap.DELIVERED;
  const isQuoteDecline = quoteItem?.status === quotesStatus.DECLINED;

  const handleChangeWarranty = (evt, checkedValue) => {
    if (!canEditOrder) {
      messageManager({
        type: MESSAGE_TYPE.error,
        messageShow: 'You do not have permission to change warranty status'
      });
      return;
    }
    updateWarrantyApiCall(
      orderDetail.id,
      { warranty: typeof checkedValue === 'boolean' ? checkedValue : evt.target.checked },
      setChangingWarrantyStatus,
      (data) =>
        setWarrantyStatus({
          status: data.warranty,
          name: data.warranty_user_name
        })
    );
  };
  const handleChangeCore = (evt, checkedValue) => {
    if (!canEditOrder) {
      messageManager({
        type: MESSAGE_TYPE.error,
        messageShow: 'You do not have permission to change core status'
      });
      return;
    }
    updateCoreApiCall(
      orderDetail.id,
      { core: typeof checkedValue === 'boolean' ? checkedValue : evt.target.checked },
      setChangingCoreStatus,
      (data) =>
        setCoreStatus({
          status: data.core,
          name: data.core_user_name
        })
    );
  };
  const updatePageInViewStatus = (id, details_open = 'false') => {
    id && APIManager.getInstance().updateInprogress({ details_open }, id);
  };

  const vinNames = [
    'vin',
    'vin number',
    'identification number',
    'vin #',
    'vin#',
    'serial number',
    's/n',
    'vin no:',
    'identification no:',
    'serial no:'
  ];

  React.useEffect(() => {
    (async () => {
      document.title = 'Order';
      await getData();
      await updatePageInViewStatus(id, 'true');
    })();

    return () => {
      firebaseSnapRef.current?.unsubscribe();
      updatePageInViewStatus(id, 'false');
      if (wsNotifications.current) {
        wsNotifications.current.close();
      }
    };
  }, []);

  React.useEffect(() => {
    if (location.state?.scroll) {
      messagesEnd.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location, orderDetail]);

  React.useEffect(() => {
    if (!id) {
      return;
    }
    wsNotifications.current = new ReconnectingWebSocket(
      `wss://${Utils.constants.API_URL.replace('https://', '')}ws/orders/${id}/?token=${
        props.userInfo.token
      }`
    );
    wsNotifications.current.onmessage = (event) => {
      if (window.location.pathname.includes('order-detail')) {
        getData();
      }
    };
  }, [id]);

  React.useEffect(() => {
    if (!orderDetail?.images) return;

    if (!orderDetail.images.length) {
      setValidImages([]);
      setCheckingImages(false);
      prevImageUrlsRef.current = 0;
      return;
    }

    // Skip re-check if image count hasn't changed (no new images added/removed)
    if (prevImageUrlsRef.current === orderDetail.images.length && validImages.length > 0) {
      return;
    }
    prevImageUrlsRef.current = orderDetail.images.length;

    setCheckingImages(true);

    const checkImages = async () => {
      const results = await Promise.all(
        orderDetail.images.map((data, i) => {
          return new Promise((resolve) => {
            if (!data?.image) {
              resolve(null);
              return;
            }

            const img = new Image();
            img.src = data.image;

            img.onload = () =>
              resolve({
                id: i,
                image: data.image
              });

            img.onerror = () => resolve(null);
          });
        })
      );

      setValidImages(results.filter(Boolean));
      setCheckingImages(false);
    };

    checkImages();
  }, [orderDetail?.images]);

  const dynamicInfo =
    orderDetail?.dynamic_attributes &&
    Object.keys(orderDetail?.dynamic_attributes)?.length > 0 &&
    Object.keys(orderDetail?.dynamic_attributes)?.map((e) => ({
      label: e,
      value: orderDetail?.dynamic_attributes?.[e],
      defaultValue: 'N/A',
      copyLabel: vinNames.includes(e.toLocaleLowerCase())
    }));

  useEffect(() => {
    const mappedValue = deliverLabelMap[orderDetail?.delivery_method] || 'N/A';

    setBasicInfo([
      {
        label: translate('customerPo'),
        value: orderDetail?.id,
        defaultValue: 'N/A'
      },
      {
        label: fixedAttributeDisplayname['order_name'] || translate('orderName'),
        value: orderDetail?.name,
        defaultValue: 'N/A',
        copyLabel: true,
        copyValue: fixedAttributeDisplayname['order_name'] || translate('orderName'),
        copyPlacement: 'label'
      },
      {
        label: translate('deliveryMethod'),
        value: ['Paid', 'Service Accepted'].includes(status)
          ? mappedValue
          : translate(orderDetail?.delivery_method),
        defaultValue: 'N/A'
      },
      {
        label: fixedAttributeDisplayname['vin'] || translate('numberScanner'),
        value: orderDetail?.vin,
        defaultValue: 'N/A',
        copyLabel: true,
        isVinCopy: true
      },
      {
        label: fixedAttributeDisplayname['shipping_address'] || translate('deliveryAddress'),
        value: orderDetail?.shipping_address,
        defaultValue: 'N/A'
      },
      {
        label: translate('location'),
        value: orderDetail?.location_name,
        defaultValue: 'N/A'
      }
    ]);
  }, [orderDetail, status]);

  // Timer effect - runs only when there are NO quotes yet
  useEffect(() => {
    const hasQuotes = orderDetail?.quotes && orderDetail.quotes.length > 0;

    if (hasQuotes) {
      // Clear timer if quotes arrive
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
      }
      setTimerElapsed('');
      return;
    }

    // Calculate elapsed time
    const updateTimer = () => {
      setTimerElapsed(formatElapsedDuration(orderDetail?.created_at));
    };

    // Initial calculation
    updateTimer();

    // Update every second
    timerIntervalRef.current = setInterval(updateTimer, 1000);

    return () => {
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
      }
    };
  }, [orderDetail?.created_at, orderDetail?.quotes]);

  // Timer for "Awaiting Service Accept" - runs when quotes exist but status NOT accepted
  useEffect(() => {
    if (!isDTCreatedOrder) {
      if (serviceAwaitingTimerRef.current) {
        clearInterval(serviceAwaitingTimerRef.current);
      }

      setServiceAwaitingElapsed('');
      return;
    }
    const firstQuoteStatus = orderDetail?.quotes?.[0]?.status || '';
    const hasQuotes = orderDetail?.quotes && orderDetail.quotes.length > 0;

    // Clear timer if:
    // 1. no quotes
    // 2. already accepted

    if (!hasQuotes || ['SERVICE ACCEPTED PENDING', 'ACCEPTED'].includes(firstQuoteStatus)) {
      // Clear timer if no quotes or already accepted
      if (serviceAwaitingTimerRef.current) {
        clearInterval(serviceAwaitingTimerRef.current);
      }
      setServiceAwaitingElapsed('');
      return;
    }

    // Calculate elapsed time from when first quote was created
    const updateTimer = () => {
      const quotesData = orderDetail?.quotes?.[0];
      setServiceAwaitingElapsed(formatElapsedDuration(quotesData?.created_at));
    };

    // Initial calculation
    updateTimer();

    // Update every second
    serviceAwaitingTimerRef.current = setInterval(updateTimer, 1000);

    return () => {
      if (serviceAwaitingTimerRef.current) {
        clearInterval(serviceAwaitingTimerRef.current);
      }
    };
  }, [orderDetail?.quotes]);

  // Calculate "Service Accepted Time" - one-time calculation when accepted
  useEffect(() => {
    // Run only for DT users
    if (!isDTCreatedOrder) {
      setServiceAcceptedElapsed('');
      return;
    }
    const firstQuoteStatus = orderDetail?.quotes?.[0]?.status || '';
    const hasQuotes = orderDetail?.quotes && orderDetail.quotes.length > 0;

    // Only show when accepted

    if (!hasQuotes || !['SERVICE ACCEPTED PENDING', 'ACCEPTED'].includes(firstQuoteStatus)) {
      setServiceAcceptedElapsed('');
      return;
    }

    // Calculate time from quote creation to acceptance
    const quotesData = orderDetail?.quotes?.[0];
    const elapsed = formatElapsedDuration(quotesData?.created_at, quotesData?.accepted_date);
    setServiceAcceptedElapsed(elapsed);
  }, [orderDetail?.quotes]);

  function getStatusLabel(status) {
    const commmonStyle = {
      color: '#fff',
      borderRadius: 'var(--sp-sm)',
      padding: 'calc(var(--sp-sm)*0.5) calc(var(--sp-md2)*1.1)',
      display: 'inline-block',
      textAlign: 'center'
    };
    switch (status) {
      case 1:
        return (
          <span
            style={{
              background: '#FFC107',
              ...commmonStyle
            }}>
            Pending
          </span>
        );
      case 2:
        return (
          <span
            style={{
              background: '#4CAF50',
              ...commmonStyle
            }}>
            Accepted
          </span>
        );
      case 3:
        return (
          <span
            style={{
              background: '#F44336',
              ...commmonStyle
            }}>
            Rejected
          </span>
        );
      default:
        return (
          <span
            style={{
              background: '#bdbdbd',
              ...commmonStyle
            }}>
            Pending
          </span>
        );
    }
  }
  const showTextButtons = Array.isArray(orderDetail?.vendors)
    ? orderDetail.vendors.some((v) => v && v.id === vendor?.id)
    : false;
  const renderTopActionButton = () => {
    const label = getTopActionButtonLabel({
      isSentQuote,
      parts: orderDetail?.parts,
      translate,
      firstQuoteStatus
    });
    if (!label) return null;
    const onClick = () => {
      setIsPartsMode(false);
      setOpenSendQuote(true);
    };
    return (
      <SendButton disabled={!isVendor || !canEditOrder} onClick={onClick} width="fit-content">
        {label}
      </SendButton>
    );
  };

  const quoteCreatedElapsed = formatElapsedDuration(orderDetail?.created_at, quotesData?.createdAt);
  const isStripe = quotesData?.stripe_charge_id !== 'NS';
  const paymentInfo = isStripe ? translate('stripe') : translate('accountBilling');
  return (
    <>
      <div
        style={{
          overflowY: 'auto',
          backgroundColor: '#fff',
          display: 'flex',
          flexDirection: 'column',
          padding: 'calc(var(--sp-lg) * 1.1) 0 var(--sp-md2) 0'
        }}>
        <PageBox>
          <Box style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff' }}>
            <Box
              style={{
                marginBottom: 'var(--sp-lg)',
                paddingLeft: 'calc(var(--sp-xs)*3.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}>
              <Box
                display="flex"
                alignItems="center"
                style={{ width: '90%', gap: 'var(--sp-md2)' }}>
                <span
                  onClick={() => navigate(-1)}
                  style={{
                    paddingTop: '0',
                    paddingBottom: '0',
                    paddingLeft: 0,
                    width: 'var(--fs-lg)',
                    height: 'var(--fs-lg)',
                    cursor: 'pointer'
                  }}>
                  <SVGImageComponentReact.IconArrowBack
                    width="var(--fs-lg)"
                    height="var(--fs-lg)"
                    style={{ color: '#1A5A78' }}
                  />
                </span>
                <PageTitleHeader title={translate('orderDetails')} showBar={false} />
              </Box>
              {canEditOrder && (
                <ButtonsContainer isBothButtonsVisible={isBothButtonsVisible}>
                  {shouldShowPartsOrderedButton() && (
                    <SendButton
                      disabled={!canEditOrder}
                      onClick={() => {
                        setIsPartsMode(true);
                        setOpenSendQuote(true);
                      }}>
                      Parts Ordered for Tech
                    </SendButton>
                  )}
                  {!isFleetOrder && (
                    <>
                      {shouldShowTopButton() && renderTopActionButton()}
                      {shouldShowAcceptAndPay() && (
                        <SendButton
                          disabled={
                            swActionLoading || selectedPartIds.length === 0 || !canEditOrder
                          }
                          onClick={acceptServiceAndPay}>
                          {swActionLoading ? (
                            <CustomSpinner size={resolveCssVarValue('--fs-xl') * 1.132075} />
                          ) : (
                            translate('acceptServiceAndPay')
                          )}
                        </SendButton>
                      )}
                    </>
                  )}
                </ButtonsContainer>
              )}
            </Box>
            <Divider />
          </Box>
          {!loading && orderDetail ? (
            <Grid container className="details-container" style={{ height: '100%' }}>
              <Grid
                item
                md={6}
                xs={12}
                style={{
                  padding: 'var(--sp-md2) var(--sp-md2) 0 var(--sp-md2)'
                }}>
                <Box
                  style={{
                    backgroundColor: '#F5F4F9',
                    padding: 'var(--sp-lg) var(--sp-md2) var(--sp-lg) var(--sp-lg)',
                    paddingBottom:
                      orderDetail?.images.length > 0 ? 'var(--sp-lg)' : 'calc(var(--sp-xxs)*2)',
                    borderRadius: 'var(--sp-md)',
                    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)'
                  }}>
                  <Box>
                    <Box
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between'
                      }}>
                      <Box>
                        <Box
                          display={'flex'}
                          alignItems={'center'}
                          justifyContent={'space-between'}>
                          <Typography
                            className="od-sectionTitle"
                            style={{ marginBottom: 'var(--sp-lg)' }}>
                            {orderDetail?.user.role === 'user'
                              ? translate('customerInfo')
                              : translate('dealerTechInfo')}
                          </Typography>
                        </Box>
                        <Box
                          className="userinfo"
                          marginY={'var(--sp-lg)'}
                          style={{ alignItems: 'center' }}>
                          <ImageZoom
                            imageSrc={orderDetail?.user?.profile?.profile_image}
                            altSrc={orderDetail?.user?.profile?.profile_image}>
                            <Avatar
                              sx={{
                                background: 'gray',
                                height: 'var(--fs-hero)',
                                width: 'var(--fs-hero)',
                                borderRadius: 'var(--sp-xs)'
                              }}
                              variant="rounded"
                              src={orderDetail?.user?.profile?.profile_image}
                            />
                          </ImageZoom>
                          <Typography className="od-name">
                            {orderDetail?.user?.profile?.full_name || orderDetail?.user?.name}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                    <Box
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 'calc(var(--sp-md) * 2)',
                        width: '100%'
                      }}>
                      <Box className="userinfo">
                        <ContactIcon type="email" size={'var(--fs-sm)'} className="contact-icon" />
                        <Typography className="usercontact">
                          {orderDetail?.user?.email || orderDetail?.user?.profile?.email}
                        </Typography>
                      </Box>

                      <Box className="userinfo">
                        <ContactIcon type="phone" size={'var(--fs-sm)'} className="contact-icon" />
                        <Typography className="usercontact">
                          {orderDetail?.user?.profile?.phone_number?.country_code &&
                          orderDetail?.user?.profile?.phone_number?.national_number
                            ? `+${orderDetail?.user?.profile?.phone_number?.country_code}${orderDetail?.user?.profile?.phone_number?.national_number}`
                            : 'N/A'}
                        </Typography>
                      </Box>
                      <Box className="userinfo">
                        <ContactIcon
                          type="address"
                          size={'var(--fs-sm)'}
                          className="contact-icon"
                        />
                        <Typography className="usercontact wrap">
                          {orderDetail?.user?.profile?.address}, {orderDetail?.user?.profile?.city},{' '}
                          {orderDetail?.user?.profile?.state} {orderDetail?.user?.profile?.zip_code}
                          , {orderDetail?.user?.profile?.country}
                        </Typography>
                      </Box>
                      {orderDetail?.user?.business_accounts.length > 0 && (
                        <Box className="userinfo">
                          <ContactIcon
                            type="business"
                            size={'var(--fs-sm)'}
                            className="contact-icon"
                          />
                          <Typography className="usercontact">
                            {translate('businessAccountInfo')} :{' '}
                            <span
                              onClick={() => setOpenBusinessInfo(true)}
                              className="business-name-link">
                              {orderDetail?.user?.business_accounts?.[0].business_name}
                            </span>
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Box>
                  {checkingImages ? (
                    <ImageSkeleton />
                  ) : validImages.length > 0 ? (
                    <ImageSliderComponent
                      images={validImages}
                      showThumbnails
                      style={{
                        position: 'sticky',
                        top: 'calc(var(--sp-xxs)*4)',
                        marginTop: 'calc(var(--sp-md2)*3)',
                        padding: 0
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        height: '61vh',
                        position: 'relative',
                        borderRadius: 'var(--sp-md)',
                        margin: '0 calc(var(--sp-xl) * 3 + var(--sp-md2)) 0 calc(var(--sp-xl) * 3)',
                        marginTop: 'calc(var(--sp-md2)*3)',
                        overflow: 'hidden',
                        background: '#F5F4F9'
                      }}>
                      <img
                        src={ThumbDefault}
                        alt="Default Thumbnail"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          display: 'block'
                        }}
                      />

                      <Box
                        sx={{
                          position: 'absolute',
                          inset: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          background: 'rgba(0,0,0,0.45)',
                          backdropFilter: 'blur(1px)',
                          background:
                            'linear-gradient(180deg, rgba(20,20,30,0.25), rgba(20,20,30,0.65))'
                        }}>
                        <Box
                          sx={{
                            padding: 'calc(var(--sp-md2)*1.132075) calc(var(--sp-xl)*1.132075)',
                            borderRadius: 'calc(var(--sp-md2)*1.50943)',
                            background: '#F5F4F9',
                            color: '#111',
                            fontWeight: 600,
                            boxShadow: '0 12px 28px rgba(0,0,0,0.28)',
                            fontSize: 'calc(var(--fs-xs)*1.698113)',
                            border: '1px solid rgba(255,255,255,0.25)',
                            backdropFilter: 'blur(5px)'
                          }}>
                          <span style={{ fontSize: 'calc(var(--fs-xs)*2.075)' }}>📷</span> No photo
                          submitted
                        </Box>
                      </Box>
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
                className="details"
                style={{
                  padding: 'var(--sp-md2) var(--sp-md2) 0 0',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                <Box
                  style={{
                    background: '#F5F4F9',
                    padding: 'var(--sp-lg) calc(var(--sp-md2)*1.5) var(--sp-lg) var(--sp-lg)',
                    borderRadius: 'var(--sp-md)',
                    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)'
                  }}>
                  <Box
                    display={'flex'}
                    alignItems={'flex-start'}
                    justifyContent={'space-between'}
                    marginBottom={'var(--sp-lg)'}
                    position={'relative'}>
                    <Box width={'100%'}>
                      <Box
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          position: 'relative',
                          gap: 'var(--sp-md2)',
                          width: '100%'
                        }}>
                        <Typography className="od-sectionTitle">
                          {translate('orderInformation')}
                        </Typography>

                        <Button
                          ref={warrantyAnchorRef}
                          onClick={() => setOpenWarrantyMenu((prev) => !prev)}
                          sx={{
                            textTransform: 'capitalize',
                            marginLeft: 'auto',
                            flexShrink: 0,
                            fontWeight: 700,
                            whiteSpace: 'nowrap',
                            borderRadius: 'var(--sp-md2)',
                            fontSize: 'calc(var(--fs-sm2) * 1.015)',
                            background:
                              'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%) !important',

                            border: '1px solid rgba(203,213,225,0.9) !important',

                            boxShadow:
                              '0 10px 25px rgba(15,23,42,0.06), inset 0 1px 0 rgba(255,255,255,0.9)',

                            backdropFilter: 'blur(10px)',
                            color: '#374151 !important',
                            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                            padding: 'calc(var(--sp-sm)*1.2) calc(var(--sp-md2)*1.2)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 'calc(var(--sp-xxs)*1.5)',

                            '&:hover': {
                              background:
                                'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%) !important',

                              borderColor: '#cbd5e1 !important',

                              boxShadow:
                                '0 8px 20px rgba(15, 23, 42, 0.08), inset 0 1px 0 rgba(255,255,255,0.9)',

                              transform: 'translateY(-1px) scale(1.01)'
                            },

                            '&:active': {
                              transform: 'translateY(0px) scale(0.995)',

                              boxShadow:
                                '0 3px 8px rgba(15,23,42,0.08), inset 0 1px 0 rgba(255,255,255,0.8)'
                            }
                          }}>
                          <span style={{ fontWeight: 500, color: '#374151' }}>Mark</span>

                          <span style={{ fontWeight: 600, color: '#1A5A78' }}>Warranty/Core</span>

                          <ArrowDropDownIcon
                            sx={{
                              fontSize: 'calc(var(--fs-xl) * 1.132075)',
                              transition: 'transform 0.2s ease',
                              transform: openWarrantyMenu ? 'rotate(180deg)' : 'rotate(0deg)',
                              color: '#9ca3af'
                            }}
                          />
                        </Button>
                      </Box>
                      <Popper
                        sx={{
                          zIndex: 9999,
                          textTransform: 'capitalize'
                        }}
                        open={openWarrantyMenu}
                        anchorEl={warrantyAnchorRef.current}
                        role={undefined}
                        placement="bottom-end"
                        transition
                        modifiers={[
                          {
                            name: 'preventOverflow',
                            options: {
                              altBoundary: true,
                              tether: false,
                              padding: 8
                            }
                          },
                          {
                            name: 'offset',
                            options: {
                              offset: [0, 4]
                            }
                          }
                        ]}>
                        {({ TransitionProps, placement }) => (
                          <Grow
                            {...TransitionProps}
                            style={{
                              transformOrigin:
                                placement === 'bottom' ? 'center top' : 'center bottom'
                            }}>
                            <Paper
                              sx={{
                                borderRadius: 'calc(var(--sp-md2)*1.32075)',
                                minWidth: 'calc(var(--fs-hero) * 4.952803)',
                                width: 'max-content',
                                overflow: 'hidden',
                                background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',

                                border: '1px solid rgba(226,232,240,0.9)',

                                boxShadow: '0 24px 60px rgba(15,23,42,0.18)',
                                zIndex: 999
                              }}>
                              <ClickAwayListener onClickAway={handleWarrantyClose}>
                                <MenuList autoFocusItem>
                                  <MenuItem
                                    disableRipple
                                    onClick={(evt) =>
                                      handleChangeWarranty(evt, !warrantyStatus?.status)
                                    }
                                    sx={{
                                      borderRadius: 'var(--sp-md2)',
                                      transition: 'all .18s ease',

                                      '&:hover': {
                                        background:
                                          'linear-gradient(90deg, rgba(59,130,246,0.08) 0%, rgba(99,102,241,0.04) 100%)',
                                        transform: 'translateX(2px)'
                                      }
                                    }}>
                                    <Box
                                      display="flex"
                                      flexDirection="column"
                                      width="100%"
                                      gap="var(--sp-xxs)">
                                      <Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        gap="var(--sp-md2)">
                                        <Typography sx={{ fontSize: 'var(--fs-md)' }}>
                                          {translate('warranty')}
                                        </Typography>
                                        {changingWarrantyStatus ? (
                                          <CustomSpinner size={resolveCssVarValue('--fs-xl')} />
                                        ) : (
                                          <Box
                                            style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              gap: 'var(--sp-sm2)'
                                            }}>
                                            <Checkbox
                                              checked={warrantyStatus?.status}
                                              disabled={changingWarrantyStatus}
                                              icon={<RoundedBoxIcon />}
                                              checkedIcon={<RoundedCheckedIcon />}
                                              sx={{
                                                padding: '1px 0px 0px 0px'
                                              }}
                                            />
                                          </Box>
                                        )}
                                      </Box>
                                      <Typography
                                        style={{
                                          fontSize: 'var(--fs-sm)',
                                          color: '#94A3B8',
                                          fontWeight: 500,
                                          letterSpacing: '0.2px',
                                          paddingLeft: '2px',
                                          lineHeight: 1.2,
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          maxWidth: 'calc(var(--fs-hero) * 4.952803)'
                                        }}>
                                        {warrantyStatus.name
                                          ? `Marked By ${warrantyStatus.name}`
                                          : 'Not Marked'}
                                      </Typography>
                                    </Box>
                                  </MenuItem>
                                  <Box
                                    sx={{
                                      height: 'calc(var(--fs-xs) * 0.094339623)',
                                      background:
                                        'linear-gradient(90deg, transparent, #e2e8f0, transparent)',
                                      margin: 'var(--sp-xxs) 0'
                                    }}
                                  />
                                  <MenuItem
                                    disableRipple
                                    sx={{
                                      borderRadius: 'var(--sp-md2)',
                                      transition: 'all .18s ease',

                                      '&:hover': {
                                        background:
                                          'linear-gradient(90deg, rgba(59,130,246,0.08) 0%, rgba(99,102,241,0.04) 100%)',
                                        transform: 'translateX(2px)'
                                      }
                                    }}
                                    onClick={(evt) => handleChangeCore(evt, !coreStatus?.status)}>
                                    <Box
                                      display="flex"
                                      flexDirection="column"
                                      width="100%"
                                      gap="var(--sp-xxs)">
                                      <Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        gap="var(--sp-md2)">
                                        <Typography sx={{ fontSize: 'var(--fs-md)' }}>
                                          {translate('core')}
                                        </Typography>
                                        {changingCoreStatus ? (
                                          <CustomSpinner size={resolveCssVarValue('--fs-xl')} />
                                        ) : (
                                          <Box
                                            style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              gap: 'var(--sp-sm)'
                                            }}>
                                            <Box>
                                              <Checkbox
                                                checked={coreStatus?.status}
                                                disabled={changingCoreStatus}
                                                icon={<RoundedBoxIcon />}
                                                checkedIcon={<RoundedCheckedIcon />}
                                                sx={{
                                                  padding: '1px 0px 0px 0px'
                                                }}
                                              />
                                            </Box>
                                          </Box>
                                        )}
                                      </Box>
                                    </Box>
                                  </MenuItem>
                                </MenuList>
                              </ClickAwayListener>
                            </Paper>
                          </Grow>
                        )}
                      </Popper>
                      {!!quotesData?.stripe_charge_id && firstQuoteStatus === 'ACCEPTED' && (
                        <Box>
                          <Typography
                            className="od-sectionTitle"
                            sx={{
                              fontWeight: '400 !important',
                              color: '#000 !important',
                              textTransform: 'capitalize',
                              marginTop: 'var(--sp-md)'
                            }}>
                            Accepted -{' '}
                            <span
                              style={{
                                fontWeight: 600,
                                letterSpacing: 'calc(var(--sp-xxs)*0.0943396))',
                                color: isStripe ? '#1E40AF' : '#6B21A8'
                              }}>
                              {paymentInfo}
                            </span>
                          </Typography>
                          {quotesData?.acceptedByVendor &&
                          quotesData?.acceptedByVendor !== 'N/A' ? (
                            <Box
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 'var(--sp-md)',
                                marginTop: 'var(--sp-lg)',
                                width: 'fit-content'
                              }}>
                              <Typography
                                className="od-sectionTitle"
                                sx={{
                                  fontWeight: '400 !important',
                                  color: '#000 !important',
                                  textTransform: 'capitalize'
                                }}>
                                Accepted By -
                              </Typography>
                              <Box display={'flex'} alignItems={'center'} gap={'var(--sp-sm)'}>
                                <PersonIcon
                                  sx={{
                                    color: '#145291',
                                    fontSize: 'var(--fs-lg)'
                                  }}
                                />
                                <Typography
                                  className="od-sectionTitle"
                                  sx={{
                                    color: '#145291 !important',
                                    textTransform: 'capitalize'
                                  }}>
                                  {quotesData?.acceptedByVendor || 'N/A'}
                                </Typography>
                              </Box>
                            </Box>
                          ) : null}
                        </Box>
                      )}
                      <Box style={{ marginTop: 'var(--sp-lg)' }} className="order-details">
                        <Box className="info-row">
                          {/* Date Created */}
                          <Box className="info-item">
                            <Box
                              className="label"
                              sx={{ display: 'flex', alignItems: 'center', gap: 'var(--sp-sm)' }}>
                              <Typography className="label">{translate('dateCreated')}</Typography>
                            </Box>
                            <Box
                              className="value-stack"
                              sx={{ display: 'flex', alignItems: 'center', gap: 'var(--sp-sm)' }}>
                              <Typography className="value-text">
                                {formatDate(orderDetail?.created_at) || 'N/A'}
                              </Typography>
                            </Box>
                          </Box>
                          <Box className="info-item">
                            <Box style={{ display: 'flex', gap: 'var(--sp-lg)' }}>
                              {/* Quote Sent - shown when quotes exist */}
                              {!!orderDetail?.quotes?.length && (
                                <Box className="info-item">
                                  <Box
                                    className="label"
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 'var(--sp-sm)'
                                    }}>
                                    <Typography className="label">Quote Sent</Typography>
                                    <CustomTooltip title="This time is when the quote was sent for the first time to the customer for this order.">
                                      <InfoIcon sx={{ fontSize: 'calc(var(--fs-xl) * 1)', cursor: 'pointer', color: '#6B7280' }} />
                                    </CustomTooltip>
                                  </Box>
                                  <Box
                                    className="value-stack"
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 'var(--sp-sm)'
                                    }}>
                                    <Typography className="value-text">
                                      {quoteCreatedElapsed}
                                    </Typography>
                                  </Box>
                                </Box>
                              )}

                              {/* Awaiting First Quote - shown when no quotes yet */}
                              {!orderDetail?.quotes?.length && (
                                <Box className="info-item">
                                  <Box
                                    className="label"
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 'var(--sp-sm)'
                                    }}>
                                    <Typography className="label">Awaiting First Quote</Typography>
                                  </Box>
                                  <Box
                                    className="value-stack"
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 'var(--sp-sm)'
                                    }}>
                                    <Box
                                      style={{
                                        backgroundColor: '#FFF3CD',
                                        border: '1px solid #FFE69C',
                                        borderRadius: 'var(--sp-xs)',
                                        padding: 'var(--sp-sm) var(--sp-sm) var(--sp-sm) 0',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 'var(--sp-sm)',
                                        minWidth: 'calc(var(--fs-hero)*2.5)'
                                      }}>
                                      <TimerOutlinedIcon
                                        sx={{
                                          fontSize: 'calc(var(--fs-xs)*1.50943)',
                                          color: 'red'
                                        }}
                                      />
                                      <Typography
                                        style={{
                                          fontSize: 'var(--fs-sm2)',
                                          color: '#FF6B6B',
                                          fontWeight: 600,
                                          letterSpacing: 'calc(var(--sp-xxs)*0.1179245)'
                                        }}>
                                        {timerElapsed}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Box>
                              )}

                              {/* Awaiting Service Accept - shown when waiting */}
                              {!!orderDetail?.quotes?.length && shouldShowAcceptAndPay() && (
                                <Box className="info-item">
                                  <Box
                                    className="label"
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 'var(--sp-sm)'
                                    }}>
                                    <Typography className="label">
                                      Awaiting Service Accept
                                    </Typography>
                                  </Box>
                                  <Box
                                    className="value-stack"
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 'var(--sp-sm)'
                                    }}>
                                    <Box
                                      style={{
                                        backgroundColor: '#FFF3CD',
                                        border: '1px solid #FFE69C',
                                        borderRadius: 'var(--sp-xs)',
                                        padding: 'var(--sp-sm) var(--sp-sm) var(--sp-sm) 0',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 'var(--sp-sm)',
                                        minWidth: 'calc(var(--fs-hero)*2.5)'
                                      }}>
                                      <TimerOutlinedIcon
                                        sx={{
                                          fontSize: 'calc(var(--fs-xs)*1.50943)',
                                          color: 'red'
                                        }}
                                      />
                                      <Typography
                                        style={{
                                          fontSize: 'var(--fs-sm2)',
                                          color: '#FF6B6B',
                                          fontWeight: 600,
                                          letterSpacing: 'calc(var(--sp-xxs)*0.1179245)'
                                        }}>
                                        {serviceAwaitingElapsed}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Box>
                              )}

                              {/* Service Accepted Time - shown when accepted */}
                              {!!orderDetail?.quotes?.length &&
                                (['SERVICE ACCEPTED'].includes(orderDetail?.status) ||
                                  ['SERVICE ACCEPTED PENDING'].includes(firstQuoteStatus)) &&
                                isDTCreatedOrder && (
                                  <Box className="info-item">
                                    <Box
                                      className="label"
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 'var(--sp-sm)'
                                      }}>
                                      <Typography className="label">Service Accepted</Typography>
                                      <CustomTooltip title="The time taken between the first quote being sent and the service being accepted.">
                                        <InfoIcon sx={{ fontSize: 'calc(var(--fs-xl) * 1)', cursor: 'pointer', color: '#6B7280' }} />
                                      </CustomTooltip>
                                    </Box>
                                    <Box
                                      className="value-stack"
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 'var(--sp-sm)'
                                      }}>
                                      <Typography className="value-text">
                                        {serviceAcceptedElapsed || 'N/A'}
                                      </Typography>
                                    </Box>
                                  </Box>
                                )}
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  <InfoCard style={{ marginTop: 0 }} info={basicInfo} />
                  <InfoCard
                    style={{ marginTop: 'var(--sp-lg)' }}
                    info={[
                      {
                        label: translate('lastUpdatedOn'),
                        value: quotesData?.updatedAt || 'N/A',
                        defaultValue: ''
                      },
                      {
                        label: translate('lastQuote'),
                        value: getQuoteAmount(firstQuoteStatus, quotesData),
                        defaultValue: ''
                      }
                    ]}
                  />
                </Box>

                <Box
                  style={{
                    background: '#F5F4F9',
                    padding:
                      'var(--sp-lg) calc(var(--sp-md2)*1.5) calc(var(--sp-md2)*1.1) var(--sp-lg)',
                    marginTop: 'var(--sp-md2)',
                    borderRadius: 'var(--sp-md)',
                    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)'
                  }}>
                  <Typography className="od-sectionTitle">
                    {translate('product')}{' '}
                    <span style={{ fontSize: 'var(--fs-md2)' }}>
                      ({orderDetail?.parts?.length > 0 ? orderDetail?.parts?.length : 0})
                    </span>
                  </Typography>
                  <TableContainer
                    component={Paper}
                    elevation={0}
                    sx={{
                      boxShadow: 'none',
                      backgroundColor: '#F5F4F9',
                      marginTop: 'var(--fs-xl)',
                      maxWidth: '100%',
                      overflowX: 'auto'
                    }}
                    className="table-container">
                    <Table
                      style={{ width: '100%', tableLayout: 'auto', backgroundColor: '#F5F4F9' }}
                      aria-label="simple table">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#E0DEEB' }}>
                          <TableCell
                            sx={{
                              width: '50%',
                              paddingY: 'calc(var(--sp-xxs)*2) !important',
                              paddingLeft: 'calc(var(--sp-xs)*3.8)',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}>
                            <OdFontScale color="rgba(47, 47, 60, 1)">
                              {translate('description')}
                            </OdFontScale>
                          </TableCell>
                          <TableCell
                            sx={{
                              width: 'calc(var(--sp-lg)*4.5)',
                              paddingY: 'calc(var(--sp-xxs)*2) !important',
                              paddingLeft: 'calc(var(--sp-xs)*3.8)',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                            align="right">
                            <OdFontScale color="rgba(47, 47, 60, 1)">
                              {translate('quantity')}
                            </OdFontScale>
                          </TableCell>
                          <TableCell
                            sx={{
                              width: 'calc(var(--sp-lg)*5)',
                              paddingY: 'calc(var(--sp-xxs)*2) !important',
                              paddingLeft: 'calc(var(--sp-xs)*3.8)',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                            align="right">
                            <OdFontScale color="rgba(47, 47, 60, 1)">
                              {isFleetOrder ? translate('itemFulfillDate') : translate('price')}
                            </OdFontScale>
                          </TableCell>
                          <TableCell
                            sx={{
                              width: 'calc(var(--sp-lg)*6)',
                              minWidth: 'calc(var(--sp-lg)*5.5)',
                              paddingY: 'calc(var(--sp-xxs)*2) !important',
                              paddingLeft: 'calc(var(--sp-xs)*5.5)',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                            align="left">
                            <OdFontScale color="rgba(47, 47, 60, 1)">
                              {translate('status')}
                            </OdFontScale>
                          </TableCell>
                          {shouldShowAcceptAndPay() && (
                            <TableCell
                              sx={{
                                width: 'calc(var(--sp-lg)*4)',
                                paddingY: 'calc(var(--sp-xxs)*2) !important',
                                paddingLeft: 'calc(var(--sp-xs)*3.8)',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}
                              align="center">
                              <OdFontScale color="rgba(47, 47, 60, 1)">{'Action'}</OdFontScale>
                            </TableCell>
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {orderDetail.parts.map((part, idx) => (
                          <React.Fragment key={idx}>
                            <TableRow sx={{ background: '#F5F4F9', position: 'relative' }}>
                              <TableCell
                                sx={{
                                  width: 'calc(var(--sp-lg)*12)',
                                  width: '60%',
                                  borderRadius: 'calc(var(--sp-xxs)*2) 0 0 calc(var(--sp-xxs)*2)',
                                  paddingY: 'calc(var(--sp-xxs)*2)',
                                  paddingLeft: 'calc(var(--sp-xs)*3.8)',
                                  paddingRight: '0px',
                                  whiteSpace: 'nowrap',
                                  wordBreak: 'break-word',
                                  overflowWrap: 'break-word',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis'
                                }}>
                                <OdFontScale
                                  style={{
                                    display: 'block',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    lineHeight: '1.4em',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    display: '-webkit-box'
                                  }}>
                                  {part.description}
                                </OdFontScale>
                              </TableCell>
                              <TableCell
                                align="right"
                                sx={{
                                  width: 'calc(var(--sp-lg)*4.5)',
                                  minWidth: 'calc(var(--fs-hero)*1.27358)',
                                  paddingY: 'calc(var(--sp-xxs)*2)',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  paddingLeft: 'calc(var(--sp-xs)*3.8)'
                                }}>
                                <OdFontScale>{part.quantity}</OdFontScale>
                              </TableCell>
                              <TableCell
                                align="right"
                                sx={{
                                  width: 'calc(var(--sp-lg)*4)',
                                  minWidth: 'calc(var(--sp-lg)*2.5)',
                                  paddingY: 'calc(var(--sp-xxs)*2)',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  paddingLeft: 'calc(var(--sp-xs)*3.8)'
                                }}>
                                <OdFontScale>
                                  {isFleetOrder
                                    ? part.fulfill_date
                                      ? dayjs(part.fulfill_date).format(SHOW_MONTH_NAME_FORMAT)
                                      : 'Not required'
                                    : part.value
                                    ? `$ ${part.value}`
                                    : '-'}
                                </OdFontScale>
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{
                                  width: 'calc(var(--sp-lg)*6)',
                                  minWidth: 'calc(var(--sp-lg)*5.5)',
                                  paddingY: 'calc(var(--sp-xxs)*2)',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  paddingLeft: 'calc(var(--sp-xs)*5.5)'
                                }}>
                                <OdFontScale fontSize="var(--fs-sm)" weight={600}>
                                  {isFleetOrder
                                    ? (() => {
                                        const fleet_status = getFleetStatusConfig(
                                          part.fleet_status
                                        );

                                        return (
                                          <span
                                            style={{
                                              padding: 'var(--sp-xxs) var(--sp-md2)',
                                              borderRadius: 'calc(var(--fs-hero)*23.56132075)', // pill shape
                                              display: 'inline-flex',
                                              alignItems: 'center',
                                              gap: 'var(--sp-sm)',

                                              color: fleet_status.color,
                                              background: fleet_status.bg,
                                              border: `1px solid ${fleet_status.border}`,

                                              boxShadow: '0 1px 2px rgba(0,0,0,0.06)' // subtle depth
                                            }}>
                                            {/* optional dot */}
                                            <span
                                              style={{
                                                width: 'calc(var(--fs-xs)*0.5660375)',
                                                height: 'calc(var(--fs-xs)*0.5660375)',
                                                borderRadius: '50%',
                                                background: fleet_status.color
                                              }}
                                            />

                                            {fleet_status.label}
                                          </span>
                                        );
                                      })()
                                    : getStatusLabel(part.status)}
                                </OdFontScale>
                              </TableCell>
                              {shouldShowAcceptAndPay() && (
                                <TableCell align="center">
                                  <div
                                    style={{
                                      display: 'flex',
                                      gap: 'var(--sp-md2)',
                                      justifyContent: 'center'
                                    }}>
                                    {selectedIcons[part.id] === 'check' ? (
                                      <CheckCircleIcon
                                        style={{
                                          color: 'green',
                                          fontSize: 'calc(var(--fs-xl)*1.132075)',
                                          cursor: 'pointer'
                                        }}
                                        onClick={() => handleIconClick(part.id, 'none')}
                                      />
                                    ) : (
                                      <CheckCircleOutlineIcon
                                        style={{
                                          color: 'green',
                                          fontSize: 'calc(var(--fs-xl)*1.132075)',
                                          cursor: 'pointer'
                                        }}
                                        onClick={() => handleIconClick(part.id, 'check')}
                                      />
                                    )}
                                    {selectedIcons[part.id] === 'cancel' ? (
                                      <CancelIcon
                                        style={{
                                          color: 'red',
                                          fontSize: 'calc(var(--fs-xl)*1.132075)',
                                          cursor: 'pointer'
                                        }}
                                        onClick={() => handleIconClick(part.id, 'none')}
                                      />
                                    ) : (
                                      <CancelOutlinedIcon
                                        style={{
                                          color: 'red',
                                          fontSize: 'calc(var(--fs-xl)*1.132075)',
                                          cursor: 'pointer'
                                        }}
                                        onClick={() => handleIconClick(part.id, 'cancel')}
                                      />
                                    )}
                                  </div>
                                </TableCell>
                              )}
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Box
                  ref={parentBoxRef}
                  style={{
                    background: '#F5F4F9',
                    padding:
                      'var(--sp-lg) calc(var(--sp-md2)*1.5) calc(var(--sp-md2)*1.3) var(--sp-lg)',
                    marginTop: 'var(--sp-md2)',
                    borderRadius: 'var(--sp-md)',
                    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between'
                  }}>
                  <div
                    ref={messagesEnd}
                    style={{
                      flex: 1
                    }}>
                    <MessagesList
                      setOpenReply={setOpenReply}
                      orderDetail={orderDetail}
                      vendorId={vendorId}
                      messages={messages}
                      setMessages={setMessages}
                      messagesLoading={messagesLoading}
                      setMessagesLoading={setMessagesLoading}
                      chatBoxHeight={chatBoxHeight}
                      showTextButtons={showTextButtons}
                    />
                  </div>
                  <Grid container marginY={'calc(var(--sp-xxs)*0.5)'} justifyContent="flex-end">
                    <Grid item>
                      {!messagesLoading &&
                        showTextButtons &&
                        messages?.length == 0 &&
                        canEditOrder && (
                          <SendButton onClick={() => setOpenStartThread(true)}>
                            {translate('startThread')}
                          </SendButton>
                        )}
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          ) : loading ? (
            <CustomSpinner fullPage />
          ) : (
            <div
              style={{
                marginLeft: 'var(--sp-md2)',
                marginTop: 'var(--sp-md2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                height: '100%',
                fontSize: 'var(--fs-lg)'
              }}>
              {translate('noDetailFound')}
            </div>
          )}
        </PageBox>
      </div>
      <ChatMessageModal
        isOpen={openStartThread}
        onClose={() => setOpenStartThread(false)}
        orderDetail={orderDetail}
        user={user}
        vendorId={vendorId}
        messageList={messages}
        type="startThread"
        modalComponent="modal"
        draggable={true}
        showOrderDetails={true}
      />
      <QuotesModal
        isOpen={openSendQuote}
        onClose={() => {
          setOpenSendQuote(false);
          setIsPartsMode(false);
        }}
        onClickClose={() => {
          setOpenSendQuote(false);
          setIsPartsMode(false);
        }}
        orderDetail={orderDetail}
        refetch={() => {
          setOpenSendQuote(false);
          setIsPartsMode(false);
          getData();
        }}
        user={user}
        vendorId={vendorId}
        quoteItem={quoteItem}
        vendorData={isVendor}
        isPartsMode={isPartsMode}
      />
      <ChatMessageModal
        isOpen={openReply}
        onClose={() => setOpenReply(false)}
        orderDetail={orderDetail}
        user={user}
        vendorId={vendorId}
        messageList={messages}
        type="reply"
        modalComponent="dialog"
        draggable={true}
        maxWidth="calc(var(--fs-hero)*15)"
      />
      <BusinessAccountModal
        isOpen={openBusinessInfo}
        onClose={() => setOpenBusinessInfo(false)}
        orderDetail={orderDetail}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userInfo: getValueFromObjectByKeys(state, ['User', 'userInfo']),
    vendor: getValueFromObjectByKeys(state, ['User', 'vendor'])
  };
};

export default connect(mapStateToProps)(OrderDetailPage);
